import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import BusinessDetail from "@/pages/BusinessDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import OwnerDashboard from "@/pages/OwnerDashboard";
import BusinessForm from "@/pages/BusinessForm";
import AdminPanel from "@/pages/AdminPanel";
import Favorites from "@/pages/Favorites";
import CategoryPage from "@/pages/CategoryPage";
import DriverPage from "@/pages/DriverPage";
import HelpHistoryPage from "@/pages/HelpHistoryPage";
import TransportCustomer from "@/pages/TransportCustomer";
import KvkkConsent from "@/pages/KvkkConsent";
import CmsHomePreview from "@/pages/CmsHomePreview";
import TransportProvider from "@/pages/TransportProvider";
import EmptyReturnSearch from "@/pages/EmptyReturnSearch";
import ProfilePage from "@/pages/ProfilePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AccountDelete from "@/pages/AccountDelete";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/arama" element={<Search />} />
            <Route path="/giris" element={<Login />} />
            <Route path="/kayit" element={<Register />} />
            <Route path="/favoriler" element={<Favorites />} />
            <Route path="/panel" element={<OwnerDashboard />} />
            <Route path="/isletme-paneli" element={<OwnerDashboard />} />
            <Route path="/isletme-ekle" element={<BusinessForm />} />
            <Route path="/isletme-duzenle/:id" element={<BusinessForm />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/surucu" element={<DriverPage />} />
            <Route path="/yardim-taleplerim" element={<HelpHistoryPage />} />
            <Route path="/profil" element={<ProfilePage />} />
            <Route path="/taleplerim" element={<TransportCustomer defaultTab="track" />} />
            <Route path="/kvkk-onay/:token" element={<KvkkConsent />} />
            <Route path="/admin/ana-sayfa-onizleme" element={<CmsHomePreview />} />
            <Route path="/tasima-yaptir" element={<TransportCustomer defaultTab="new" />} />
            <Route path="/tasima-pazari" element={<TransportProvider />} />
            <Route path="/bos-donus-ara" element={<EmptyReturnSearch />} />
            <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
            <Route path="/hesap-silme" element={<AccountDelete />} />
            <Route path="/kategori/:slug" element={<CategoryPage />} />
            <Route path="/firma/:slug" element={<BusinessDetail />} />
            <Route path="/isletme/:slug" element={<BusinessDetail />} />
            <Route path="/:province/:district/:slug" element={<CategoryPage />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
